import { IEquipmentGroup } from '../../equipmentGroup.types'
import eventBus from '../../../../services/eventBus'

const created = (group: IEquipmentGroup) => {
  eventBus.pub('equipment.group.created', group)
}

const updated = (group: IEquipmentGroup) => {
  eventBus.pub('equipment.group.updated', group)
}

const deleted = (id: IEquipmentGroup['id']) => {
  eventBus.pub('equipment.group.deleted', id)
}

const equipmentGroupsEvents = { created, updated, deleted }
export default equipmentGroupsEvents
